import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Query, Req } from '@nestjs/common';
import { DistrictService } from './district.service';
import { DistrictDTO, DistrictStatusDTO, getstatesDTO } from './dto/district.dto';
import { DistrcitIdRequest,DistrictCodeRequest, DistrictNameRequest } from './dto/districtname.request';
import { DistrictResponseModel } from './dto/district-response.model';
import { AllDistrictResponseModel } from './dto/all-district-response.model';
import { DistrictStatusWiseResponseModel } from './dto/district-status-response.model';
import { ApiQuery, ApiTags } from '@nestjs/swagger';

@ApiTags('District')
@Controller('district')
export class DistrictController {
    constructor(
        private districtService: DistrictService
    ) {}    

    @Post('/createDistrict')
    @ApiQuery({name:'apiVersion'})
    async createDistrict(@Query() queryParams,@Body() districtDto:DistrictDTO,isUpdate:boolean=false,@Req() request:Request):Promise<DistrictResponseModel>{
        try {
            return await this.districtService.createDistrict(queryParams,districtDto,false,request);
        } catch (error) {
            return errorHandler(DistrictResponseModel,error);
        }
    }

    @Post('/updateDistrict')
    @ApiQuery({name:'apiVersion'})
    async updateDistrict(@Query() queryParams,@Body() districtDto:DistrictDTO,isUpdate:boolean=true,@Req() request:Request):Promise<DistrictResponseModel>{
        try {
            return await this.districtService.createDistrict(queryParams,districtDto,true,request);
        } catch (error) {
            return errorHandler(DistrictResponseModel,error);
        }
    }

    @Post('/getAllDistricts')
    @ApiQuery({name:'apiVersion'})
    async getAllDistricts(@Query() queryParams, @Req() request: Request): Promise<AllDistrictResponseModel> {
        try {
            return await this.districtService.getAllDistricts(queryParams, request);
        } catch (error) {
            return errorHandler(AllDistrictResponseModel, error);
        }
    }

    @Post('/getDistrictByDistrictName')
    @ApiQuery({name:'apiVersion'})
    async getDistrictByDistrictName(@Query() queryParams, @Body() districtNameRequest: DistrictNameRequest, @Req() request:Request): Promise<DistrictResponseModel>{
        try {
           return await this.districtService.getDistrictByDistrictName(queryParams,districtNameRequest.districtName, request);
        } catch (error) {
           return errorHandler(DistrictResponseModel, error);
        }
    }

    @Post('/getDistrictByDistrictId')
    @ApiQuery({name:'apiVersion'})
    async getDistrictByDistrictId(@Query() queryParams, @Body() distrcitIdRequest:DistrcitIdRequest, @Req() request:Request ): Promise<DistrictResponseModel>{
        try {
           return await this.districtService.getDistrictByDistrictId(queryParams,distrcitIdRequest.Id,request);
        } catch (error) {
           return errorHandler(DistrictResponseModel, error);
        }
    }
  
    @Post('/getAllActiveDistricts')
    @ApiQuery({name:'apiVersion'})
    async getAllActiveDistricts(@Query() queryParams, @Req() request:Request): Promise<AllDistrictResponseModel>{
        try{
          return await this.districtService.getAllActiveDistricts(queryParams,request);
        } catch(error) {
          return errorHandler(AllDistrictResponseModel,error);
        }
    }

    @Post('/getActiveDistrictsCount')
    @ApiQuery({name:'apiVersion'})
    async getActiveDistrictsCount(@Query() queryParams, @Req() request:Request): Promise<DistrictStatusWiseResponseModel> {
        try {
            return await this.districtService.getActiveDistrictsCount(queryParams, request);
        } catch (error) {
            return errorHandler(DistrictStatusWiseResponseModel, error);
        }
    }
   
    @Post('/updateDistrictStatus')
    @ApiQuery({name:'apiVersion'})
    async updateDistrictStatus(@Query() queryParams,@Body() districtStatusDto:DistrictStatusDTO,@Req() request:Request): Promise<DistrictResponseModel>{
        try{
          return await this.districtService.updateDistrictStatus(queryParams,districtStatusDto,request);
        } catch (error) {
          return errorHandler(DistrictResponseModel, error);
        }
    }
    @Post('/stateid')
    @ApiQuery({name:'apiVersion'})
    async getdistrictbystateid(@Query() queryParams,@Body() getstatesDTO:getstatesDTO,request: Request): Promise<AllDistrictResponseModel> {
        try {
            return await this.districtService.getdistrictbystateid(queryParams,getstatesDTO,request);
        } catch (error) {
            return errorHandler(AllDistrictResponseModel, error);
        }
    }

}